import { Box, Popover, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import React from "react";
import { GridDataSource, GridGetRowsResponse, GridGetRowsParams, GridColDef, useGridApiRef, GridDataSourceCache, GridDataSourceCacheDefault, GridRenderCellParams, GridActionsCellItem } from "@mui/x-data-grid";
import { GridRowModesModel } from "@mui/x-data-grid";
import TabPanel from "@mui/lab/TabPanel";
import { formatNumber } from '../../Common/FormatNumber';
import CustomDataGrid from "../../Common/CustomDataGrid";
import DataExplorationIcon from '@mui/icons-material/DataExploration';

export default function TopOpportunity({ mode, height }: { mode: string, height: number }){
    const [value, setValue] = React.useState('R');

    const apiRef = useGridApiRef();
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [columns, setColumns] = React.useState<GridColDef[]>([
        {
            field: 'entity_cust_id',
            headerName: 'Cust ID',
            renderHeader: (params) => {
                return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
            },
            // width: 80,
            flex: 0.5,
            align: 'center',
            headerAlign: 'center',
            type: 'string',
        },
        {
            field: 'customer_name',
            headerName: 'Customer',
            renderHeader: (params) => {
                return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
            },
            // width: 210,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            type: 'string',
            filterable: true,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Tooltip id={`tooltip-${params.row.id}`} title={params.row.whisper}>
                        <span style={{ color: 'blue', borderBottom: '1px dashed blue', cursor: 'pointer' }}>{params.value}</span>
                    </Tooltip>
                )
            },
        },
        {
            field: 'channel_descr',
            headerName: 'Whisper Type',
            renderHeader: (params) => {
                return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Whisper Type</span>;
            },
            // width: 220,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            type: 'string',
            filterable: false,
            renderCell: (params: GridRenderCellParams) => {
                return <span style={{ color: params.row.color }}>{params.value}</span>;
            },
        },
        // {
        //     field: 'condition',
        //     headerName: 'Condition',
        //     renderHeader: (params) => {
        //         return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
        //     },
        //     width: 90,
        //     align: 'center',
        //     headerAlign: 'center',
        //     type: 'number',
        //     filterable: false,
        // },
        // {
        //     field: 'goal',
        //     headerName: 'Goal',
        //     renderHeader: (params) => {
        //         return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
        //     },
        //     width: 90,
        //     align: 'center',
        //     headerAlign: 'center',
        //     type: 'number',
        //     filterable: false,
        // },
        {
            field: 'rev_impact',
            headerName: 'Revenue Estimated Impact',
            renderHeader: (params) => {
                return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Revenue <br/> Estimated Impact</span>;
            },
            // width: 170,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            type: 'number',
            filterable: false,
            renderCell: (params: GridRenderCellParams) => {
                return <span style={{ color: 'darkgreen' }}>{formatNumber(params.value)}</span>;
            },
        },
        {
            field: 'gp_impact',
            headerName: 'Gross Profit Estimated Impact',
            renderHeader: (params) => {
                return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Gross Profit <br/> Estimated Impact</span>;
            },
            // width: 170,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            type: 'number',
            filterable: false,
            renderCell: (params: GridRenderCellParams) => {
                return <span style={{ color: 'blue' }}>{formatNumber(params.value)}</span>;
            },
        }
    ]);

    const [lowTTLCache, setLowTTLCache] = React.useState<GridDataSourceCache>(() => new GridDataSourceCacheDefault({ ttl: 1000 * 10 }));

   
    const gridDataSource: GridDataSource = {
        getRows: async (params: GridGetRowsParams): Promise<GridGetRowsResponse> => {
            let urlDict = {};
      
            //   if (params.paginationModel.page > 0) {
            urlDict = {paginationModel: JSON.stringify(params.paginationModel)};
            //   }
            if (params.filterModel.items.length > 0) {
                // urlDict = {filterModel: JSON.stringify(params.filterModel)};
                urlDict = { ...urlDict, filterModel: JSON.stringify(params.filterModel) };
            }
            if (params.sortModel.length > 0) {
                // urlDict = {sortModel: JSON.stringify(params.sortModel)};
                urlDict = { ...urlDict, sortModel: JSON.stringify(params.sortModel) };
            }
        
            const urlParams = new URLSearchParams(urlDict);
            const urlParamsString = urlParams.size > 0 ? `?${urlParams.toString()}&value=${value}&entity_id=${localStorage.getItem('entity_id')}` : `?value=${value}&entity_id=${localStorage.getItem('entity_id')}`;
            const response = await fetch(`/dashboard/top-opportunities/${urlParamsString}`, {
                method: 'GET',
            });
            const data = await response.json();
            return {
                rows: data.rows,
                rowCount: data.rowCount,
            };
        },
    }

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', borderRadius: '6px !important', backgroundColor: 'white', border: '1px solid #f0f0f0 !important'}}>  
            <Box sx={{ width: '100%', typography: 'body1', height: '100%', margin: 0, padding: 0 }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', padding: 0 }}>
                        <Tabs 
                            variant="scrollable"
                            scrollButtons
                            allowScrollButtonsMobile
                            selectionFollowsFocus
                            onChange={handleChange} 
                            aria-label="lab API tabs example" 
                            value={value}
                            centered
                        >
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Revenue Expansion" value="R" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Operational Efficiency" value="O" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Price Recovery" value="P" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Trends" value="T" />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} sx={{ margin: 0, padding: 0 }}>
                        <CustomDataGrid
                            message="No top opportunities found."
                            mode={mode}
                            columns={columns}
                            gridDataSource={gridDataSource}
                            sortModel={[]}
                            apiRef={apiRef}
                            rowModesModel={rowModesModel}
                            lowTTLCache={lowTTLCache}
                            navigate={true}
                            defineMaxHeight={height}
                            title="Top Opportunities"
                            url={`/dashboard/top-opportunities/?value=${value}`}
                            exportUrl={`/top-opportunities/export/${value}/`}
                        />
                    </TabPanel>
                </TabContext>
            </Box>
        </Box>
    )
}